export default __webpack_public_path__ + "static/media/quoteman_small.cf25fd6d.svg";